import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/providers/apiService/api.service';
import { StorageService } from 'src/app/providers/storageService/storage.service';
import { ToastService } from 'src/app/providers/toastService/toast.service';

@Component({
  selector: 'app-compose',
  templateUrl: './compose.page.html',
  styleUrls: ['./compose.page.scss'],
})
export class ComposePage implements OnInit {
  composeMessageForm: FormGroup;
  user: any;
  errorMessages = {
    message: [{ type: 'required', message: ' Enter  message' }],
    // subject: [{ type: 'required', message: ' Enter  subject' }],
    // threadType: [{ type: 'required', message: ' Select Query Type' }],
    name: [{ type: 'required', message: ' Enter Name.' }],
    email: [
      { type: 'required', message: ' Enter Email Address.' },
      { type: 'pattern', message: 'Invalid Email Address.' },],
  };
  isAdmin = false;
  userData: any;
  constructor(
    public formBuilder: FormBuilder,
    private apiService: ApiService,
    public router: Router,
    private storageService: StorageService,
    private toastService: ToastService
  ) {
    this.composeMessageForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: [
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$'),
        ]),
      ],
      subject: [''],
      threadType: [''],
      message: ['', Validators.required]
    });
  }
  ionViewWillEnter() {
    this.getUser();
  }
  ngOnInit() {
    this.storageService.getObject('mbeUser').then((userResult) => {
      //console.log('local User::', userResult);
      this.userData = userResult;
      //console.log('this.userData', this.userData);
      if (userResult && userResult.role === '2') {
        this.isAdmin = true;
      }
      this.composeMessageForm.patchValue({
        name: userResult?.first_name,
        email: userResult?.email
      });
    });
  }
  sendMessage() {
    if (this.composeMessageForm.valid) {
      this.toastService.presentLoading();
      this.apiService.post('messages/create-direct-message', this.composeMessageForm.value).subscribe(
        (res) => {
          this.toastService.dismissLoading();
          if (res.error === false) {
            this.toastService.presentToast(
              'success',
              'Message Sent Successfully  '
            );
            this.composeMessageForm.controls.subject.reset();
            this.composeMessageForm.controls.threadType.reset();
            this.composeMessageForm.controls.message.reset();
          } else {
            this.toastService.presentToast('danger', res.message);
          }
        },
        (err) => {
          this.toastService.dismissLoading();
        }
      );
    } else {
      // eslint-disable-next-line guard-for-in
      for (const property in this.composeMessageForm.value) {
        this.composeMessageForm.controls[property].markAsTouched();
      }
      this.composeMessageForm.markAsTouched();
    }
  }

  getUser() {
    this.storageService
      .getObject('userInfo')
      .then((result) => {
        if (result != null) {
          //console.log('userInfo: ' + JSON.stringify(result));
          this.user = JSON.stringify(result);
          this.composeMessageForm.controls.User.setValue(this.user);
        }
      })
      .catch((e) => {
        //console.log('error: ' + e);
        // Handle errors here
      });
  }
}
